{ "name": "night", "sunDir": [0.40, 0.80, 0.45], "sunColor": "#9DB6FF", "sunIntensity": 0.85,
  "skyColor": "#4A5C9C", "groundColor": "#1C2238", "hemiIntensity": 0.75,
  "hazeAmount": 0.12, "tint": "#5A78D8", "tintAmount": 0.30, "valueScale": 0.72 }
